// src/auth/index.js
/**
 * Auth Module - Barrel Export
 * Single import point for all authentication and authorization utilities
 * 
 * Usage:
 * import { PERMISSIONS, hasPermission, HasPermission } from '@/auth';
 */

import * as constants from './constants';
import * as authUtils from './authUtils';
import ProtectedButton from './ProtectedButton';
import HasPermission from './HasPermission';
import HasRole from './HasRole';
import ProtectedRoute from './ProtectedRoute';
import RoleBadge from './RoleBadge';

// Export all constants
export * from './constants';

// Export all auth utilities
export * from './authUtils';

// Export all components
export { default as ProtectedButton } from './ProtectedButton';
export { default as HasPermission } from './HasPermission';
export { default as HasRole } from './HasRole';
export { default as ProtectedRoute } from './ProtectedRoute';
export { default as RoleBadge } from './RoleBadge';

// Default export (optional - for convenience)

export default {
  // Constants
  ...constants,
  
  // Utils
  ...authUtils,
  
  // Components
  ProtectedButton,
  HasPermission,
  HasRole,
  ProtectedRoute,
  RoleBadge,
};